import instance from "../../index";
import {PagedList} from "../../../models/paged-list";
import {AppMessage} from "../../../models/appMessage";
import {AppMessagesFilters} from "../../../filters/app-messages-filters";
import {CreateAppMessageRequest} from "../../../models/requests/create-app-message-request";
import {UpdateAppMessageRequest} from "../../../models/requests/update-app-message-request";
import {BaseResponse} from "../../../models/base-response";

export const useAppMessagesService = () => {

    async function deleteAppMessage(id: string) {
        const response = await instance.delete(`/v1/backoffice/app-messages/${id}`);
        return response?.data;
    }

    async function getAppMessages(filter?: AppMessagesFilters): Promise<PagedList<AppMessage>> {
        const response = await instance.get<BaseResponse<PagedList<AppMessage>>>('/v1/backoffice/app-messages/', {
            params: filter
        });
        return response?.data?.data;
    }


    async function createAppMessage(request: Partial<CreateAppMessageRequest>): Promise<AppMessage> {
        const response = await instance.post<AppMessage>(`/v1/backoffice/app-messages/`, request);
        return response?.data;
    }

    async function editAppMessage(request: Partial<UpdateAppMessageRequest>, id: string | string [] | undefined): Promise<AppMessage> {
        return (await instance.put<AppMessage>(`/v1/backoffice/app-messages/${id}`, request))?.data;
    }


    return {
        deleteAppMessage,
        getAppMessages,
        createAppMessage,
        editAppMessage,
    }
}

export default useAppMessagesService;